export const CDP_SCREENER_OUTCOME_PARAM_KEYS = {
  D: 'd',
  M: 'm',
  Y: 'y',
  G: 'g',
  FIRST_NAME: 'firstName',
  EMAIL: 'email',
  ZIP_CODE: 'zipCode',
  PATIENT_STATE: 'patientState',
  PATIENT_ZIP_CODE: 'patientZipCode',
  PATIENT_ZIP: 'patientZip',
  CONDITION: 'condition',
  ALL_SCREENED_TA: 'allScreenedTA',
  LAST_SCREENED_TA: 'lastScreenedTA',
  AC: 'ac',
} as const;

export const CDP_PATIENT_ZIP_CODE_PARAM_KEYS = [
  CDP_SCREENER_OUTCOME_PARAM_KEYS.PATIENT_ZIP_CODE,
  CDP_SCREENER_OUTCOME_PARAM_KEYS.PATIENT_ZIP,
];

export const CDP_ZIP_CODE_PARAM_KEYS = [
  CDP_SCREENER_OUTCOME_PARAM_KEYS.ZIP_CODE,
  ...CDP_PATIENT_ZIP_CODE_PARAM_KEYS,
];

export const CDP_CONDITION_PARAM_KEYS = [
  CDP_SCREENER_OUTCOME_PARAM_KEYS.CONDITION,
  CDP_SCREENER_OUTCOME_PARAM_KEYS.ALL_SCREENED_TA,
  CDP_SCREENER_OUTCOME_PARAM_KEYS.LAST_SCREENED_TA,
  CDP_SCREENER_OUTCOME_PARAM_KEYS.AC,
];

export const CDP_FLAT_OUTCOME_PARAM_KEYS = [
  CDP_SCREENER_OUTCOME_PARAM_KEYS.D,
  CDP_SCREENER_OUTCOME_PARAM_KEYS.M,
  CDP_SCREENER_OUTCOME_PARAM_KEYS.Y,
  CDP_SCREENER_OUTCOME_PARAM_KEYS.G,
  CDP_SCREENER_OUTCOME_PARAM_KEYS.FIRST_NAME,
  CDP_SCREENER_OUTCOME_PARAM_KEYS.EMAIL,
  CDP_SCREENER_OUTCOME_PARAM_KEYS.ZIP_CODE,
  CDP_SCREENER_OUTCOME_PARAM_KEYS.PATIENT_ZIP_CODE,
  CDP_SCREENER_OUTCOME_PARAM_KEYS.PATIENT_ZIP,
  ...CDP_CONDITION_PARAM_KEYS,
];
